import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-collapsed-menu',
  templateUrl: './collapsed-menu.component.html',
  styleUrls: ['./collapsed-menu.component.scss'],
})
export class CollapsedMenuComponent implements OnInit {
  ScreenSize = ScreenSize;
  modalStyle: string = this.layoutService.screenSize > this.ScreenSize.MOBILE_L ? 'auto-height' : '';
  menuItems: any = {};
  index: number;
  activeIndex: number | null = null;

  @Output() navigationOccurred = new EventEmitter<void>();
  @Output() deactivateItems = new EventEmitter<void>();

  constructor(
    private nav: NavigationService,
    private layoutService: LayoutService,
    @Inject(MAT_DIALOG_DATA) public data: any  // Inject the dialog data here
  ) {
    this.menuItems = data.menuItems;
    this.index = data.i;
  }

  ngOnInit() {
  }

  navigateTo(url: string | null, mainMenuItem: any, subMenuItem: any, queryParams?: any) {
    if (!url) {
      return;
    }
    this.deactivateItems.emit();
    this.nav.deactivateMenuItems();
    if(mainMenuItem && mainMenuItem.menuItems && subMenuItem) {
      mainMenuItem.menuItems.forEach((item: any) => {
        item.active = false;
      });
      subMenuItem.active = true;
    } else if (mainMenuItem) {
      mainMenuItem.active = true;
    }
    this.nav.UpdateMenuItem(mainMenuItem, this.index);
    this.nav.Navigate(url, queryParams);
    this.navigationOccurred.emit();
  }

}
